import getScenarioStore from '../selectors/getScenarioStore';
import { mutatorAction } from 'satcheljs';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default mutatorAction(
    'setCurrentSearchQueryId',
    (currentSearchQueryId: string, scenarioId: SearchScenarioId): void => {
        getScenarioStore(scenarioId).currentSearchQueryId = currentSearchQueryId;
    }
);
